var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPancile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_177_3123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1025 14.1807C15.5976 14.1808 16 14.5893 16 15.0908C15.9998 15.5932 15.5975 15.9999 15.1025 16H10.0264C9.53151 15.9997 9.12911 15.5931 9.12891 15.0908C9.12891 14.5893 9.53139 14.1809 10.0264 14.1807H15.1025ZM8.21484 0.850586C9.02605 -0.190661 10.4408 -0.286555 11.582 0.621094L12.8926 1.66309C13.4302 2.08351 13.7885 2.63785 13.9111 3.2207C14.0525 3.86175 13.9019 4.49158 13.4775 5.03613L5.66797 15.1357C5.30955 15.5943 4.78075 15.8518 4.21484 15.8613L1.10254 15.8994C0.932888 15.8994 0.791763 15.7853 0.753906 15.623L0.0458984 12.5557C-0.0767053 11.992 0.0459745 11.409 0.404297 10.96L5.94141 3.79395C6.03573 3.67929 6.20517 3.66106 6.31836 3.74609L8.64844 5.59961C8.79934 5.72376 9.00675 5.79037 9.22363 5.76172C9.68581 5.70439 9.99736 5.28405 9.9502 4.83496C9.92187 4.6057 9.80811 4.41478 9.65723 4.27148C9.60567 4.22974 7.39355 2.45605 7.39355 2.45605C7.25216 2.34138 7.22376 2.13062 7.33691 1.98828L8.21484 0.850586Z",
    fill: "#25262D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_3123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancile);
export default __webpack_public_path__ + "static/media/Pancile.24a5d89d4b55869cab6f99da54d8a044.svg";
export { ForwardRef as ReactComponent };